import { lazy } from 'react';

// project imports
import Loadable from "../components/Loadable"
import AuthLayout from "../layout/AuthLayout"

const Login = Loadable(lazy(() => import('../page/Auth/Login')));
const Signup = Loadable(lazy(() => import('../page/Auth/Signup')));
const ChangePass = Loadable(lazy(() => import('../page/Auth/ChangePass')));
const ForgotPass = Loadable(lazy(() => import('../page/Auth/ForgotPass')));
const ResetPass = Loadable(lazy(() => import('../page/Auth/ResetPass')));
const Page404 = Loadable(lazy(() => import('../page/404')));

const AuthRoutes = {
  path: '/auth',
  element: <AuthLayout />,
  children: [
    {
      path: 'signup',
      element: <Signup />
    },
    {
      path: 'login',
      element: <Login />
    },
    {
      path: 'forgot',
      element: <ForgotPass />
    },
    {
      path: 'reset',
      element: <ResetPass />
    },
    {
      path: 'change-pass',
      element: <ChangePass />
    },
    {
      path: '*',
      element: <Page404 />
    }
  ]
};

export default AuthRoutes;
